import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageClothingOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-4">
      <GenerateImageOptionButton
        title="Summer dress"
        value="wearing a long summer dress"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Bikini"
        value="wearing a bikini"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Skirt"
        value="wearing a skirt"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Mini-skirt"
        value="wearing a mini-skirt"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Latex skirt"
        value="wearing a latex skirt"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton title="Jeans" value="wearing jeans" onClick={props.updatePrompt} />
      <GenerateImageOptionButton
        title="Lab coat"
        value="wearing a lab coat and shirt"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Teacher"
        value="wearing a pencil skirt with a blazer and a shirt, teaching in front of the class"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Pajamas"
        value="wearing a comfy pyjamas, sitting on the bed"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Tank top"
        value="wearing a tank top and shorts"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Sport"
        value="wearing a sport outfit, in a gym"
        onClick={props.updatePrompt}
      />
    </div>
  )
}

export default GenerateImageClothingOptions
